import React, { Component } from 'react';
import Helper from 'helpers/util';
import _ from 'lodash';

class LocationSearch extends Component {
	autoCompleteService = null;
	placesService = null;
	geocoder = null;
	inputRef = React.createRef();
	focussedResult = null;
	state = {
		loading: true,
		geolocating: false,
		geolocationSupport: false,
		inputValue: '',
		inputValueFromProps: null,
		searchResults: []
	};

	static getDerivedStateFromProps(nextProps, prevState) {
		// Prefill search input if location already searched
		if (
			nextProps.currentLocation &&
			prevState.inputValueFromProps !== nextProps.currentLocation.formatted_address
		) {
			const inputValue = nextProps.currentLocation.formatted_address;
			return { inputValue, inputValueFromProps: inputValue };
		}
		return null;
	}

	componentDidMount() {
		Helper.pubsub.subscribe('googleMapsLoaded', () => {
			// init store finder
			this.initAutoComplete();
		});

		// disable cms form submissions
		document.getElementById('form').addEventListener(
			'submit',
			function(evt) {
				evt.preventDefault();
			},
			true
		);
	}

	initAutoComplete() {
		// Setup autocomplete service
		this.autoCompleteService = new window.google.maps.places.AutocompleteService();

		// Setup places service
		this.placesService = new window.google.maps.places.PlacesService(
			document.getElementById('places-attributions') // Without an attribution element, the places getDetails method fails
		);

		// init Geocoder class for html5 geolocation
		this.geocoder = new window.google.maps.Geocoder();

		this.sessionToken = new window.google.maps.places.AutocompleteSessionToken();

		// see if browser supports geolocation
		if (navigator.geolocation) {
			this.setState({
				loading: false,
				geolocationSupport: true
			});
			// call geolocate on load
			if (this.props.geolocateOnInit) {
				this.geolocate();
			}
		} else {
			this.setState({
				loading: false
			});
		}
	}

	geolocate() {
		this.setState({
			geolocating: true
		});

		navigator.geolocation.getCurrentPosition(
			position => {
				var latlng = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};

				this.geocoder.geocode(
					{
						location: latlng
					},
					(results, status) => {
						// set geolocation loading state
						this.setState({
							geolocating: false
						});

						if (status === 'OK') {
							if (results[0]) {
								// pass address back to store finder map
								this.props.locationSelect(results[0]);
								// update input with formated geolocation address
								this.setState({ inputValue: results[0].formatted_address });
							} else {
								window.alert('No results found');
							}
						} else {
							// set geolocation loading state
							this.setState({
								geolocating: false
							});
							window.alert('Geocoder failed due to: ' + status);
						}
					}
				);
			},
			error => {
				console.error('There was an error with HTML5 geolocation.', error);
				this.setState({
					geolocating: false
				});
			}
		);
	}

	getPlacePredictions = request => {
		return new Promise((resolve, reject) => {
			this.autoCompleteService.getPlacePredictions(
				{
					sessionToken: this.sessionToken,
					componentRestrictions: { country: 'AU' },
					...request
				},
				(results, status) => {
					if (status === 'OK' || status === 'ZERO_RESULTS') {
						resolve(results || []);
					} else {
						reject(`AutoCompleteService failed with status: ${status}`);
					}
				}
			);
		});
	};

	search = value => {
		this.setState({ loading: true });
		Promise.all([
			this.getPlacePredictions({ input: value, types: ['(regions)'] }),
			this.getPlacePredictions({ input: value, types: ['geocode'] })
		])
			.then(res => {
				const flattenedResults = _.uniqBy(_.flatten(res), 'place_id').slice(0, 5);
				this.setState({ loading: false, searchResults: flattenedResults });
			})
			.catch(error => {
				console.error(error);
				this.setState({ loading: false, searchResults: [] });
			});
	};

	debouncedSearch = _.debounce(this.search, 250);

	handleInputChange = event => {
		const { value } = event.target;
		this.setState({ inputValue: value });
		if ([...value].length > 0) {
			this.debouncedSearch(value);
		}
	};

	handleResultClick(result) {
		this.setState({ searchResults: [], inputValue: result.description });
		this.placesService.getDetails(
			{ placeId: result.place_id, fields: ['formatted_address', 'geometry'], sessionToken: this.sessionToken },
			(details, status) => {
				if (status === 'OK') {
					this.props.locationSelect({ ...details, formatted_address: result.description });
				} else {
					console.error(status);
				}
			}
		);
		this.sessionToken = new window.google.maps.places.AutocompleteSessionToken();
	}

	renderGeolocation() {
		if (this.state.geolocationSupport) {
			if (this.state.geolocating) {
				// loading geolocation
				return (
					<div className="location-search-geolocate">
						<div className="loader geolocation-loader" />
					</div>
				);
			} else {
				return (
					<div className="location-search-geolocate is-clickable" onClick={this.geolocate.bind(this)}>
						<span className="icon icon-geolocation" />
						<span className="location-search-geolocate-text">Use my location</span>
					</div>
				);
			}
		}
		return null;
	}

	render() {
		return (
			<div className="location-search">
				<div className="location-search-inner">
					<input
						type="text"
						placeholder="Search by suburb or postcode"
						value={this.state.inputValue}
						onChange={this.handleInputChange}
						disabled={this.state.geolocating}
						ref={this.inputRef}
						onFocus={this.handleInputFocus}
						onBlur={this.handleInputBlur}
					/>

					<label htmlFor="locationSearch" className="location-search-icon icon icon-search" />
				</div>

				{this.renderGeolocation()}

				{/* Search results */}
				{this.state.searchResults.length > 0 ? (
					<div className="location-search-results" ref={ref => (this.resultsRef = ref)}>
						{this.state.searchResults.map(result => (
							<button
								type="button"
								key={result.place_id}
								className="location-search-result"
								onClick={() => {
									this.handleResultClick(result);
								}}
							>
								<span>{result.description}</span>
							</button>
						))}
					</div>
				) : null}

				<div id="places-attributions" />
			</div>
		);
	}
}

export default LocationSearch;
